import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appLazyLoad]'
})
export class LazyLoadDirective implements OnInit {
  private observer: IntersectionObserver;
  @Input() isLoggedIn: boolean;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = this.elementRef.nativeElement as HTMLVideoElement;

        if ((entry as any).isIntersecting && video.src) {
          if (!this.isLoggedIn) {
            video.play().catch((error) => {
              if (error.name === 'NotFoundError') {
                console.error('Video not found:', video.src);
                // Handle the 404 error here
              } else if (error.name === 'NotSupportedError') {
                console.error('Video NotSupportedError:', video.src);
                // Handle the 404 error here
              } else {
                console.error('Error playing video:', error);
              }
            });
          }
        } else {
          video.pause();
        }
      });
    });

    this.observer.observe(this.elementRef.nativeElement);
  }
}


// WEBPACK FOOTER //
// ./src/app/video/lazyload.directive.ts